export const API_DOCS_URL = process.env.NEXT_PUBLIC_API_DOCS_URL;
export const SUPPORT_EMAIL = process.env.NEXT_PUBLIC_SUPPORT_EMAIL;
export const SMS_PRICE_PER_MESSAGE = process.env.NEXT_PUBLIC_SMS_PRICE_PER_MESSAGE;
export const PRICE_PER_SMS = 0.07;
export const PRICE_PER_FAX = 0.07;
export const IP2GEO_MONTHLY_USD = 100;
export const EMAIL_MONTHLY_USD = 30;
export const EMAIL_INCLUDED_PER_MONTH = 10000;
export const ANALYTICS_MONTHLY_USD = 50;
export const ADDRESS_MONTHLY_USD = 99;
export const PRICE_PER_EMAIL_CAMPAIGN = 0.01;

export const MAX_DEVELOPERS_PER_COMPANY = 10;

export const ANALYTICS_REGIONS = ["us-east-1", "us-west-1", "eu-west-1", "ap-southeast-1"] as const;
export const ANALYTICS_DEFAULT_REGION = "us-west-1";

export interface AnalyticsServerType {
  id: string;
  name: string;
  specs: string;
  note: string;
  cost: string;
  recommended?: boolean;
}

export const ANALYTICS_SERVER_TYPES: AnalyticsServerType[] = [
  {
    id: "t3.large",
    name: "t3.large",
    specs: "2 vCPU · 8 GB RAM",
    note: "Most production sites",
    cost: "$0.083 / hr",
    recommended: true,
  },
  {
    id: "m5.xlarge",
    name: "m5.xlarge",
    specs: "4 vCPU · 16 GB RAM",
    note: "High-volume analytics",
    cost: "$0.192 / hr",
  },
];
export const ANALYTICS_DEFAULT_INSTANCE_TYPE = "t3.large";

export enum ProductCategory {
  SMS = "sms",
  ADDRESS = "address",
  FAX = "fax",
  IP2GEO = "ip2geo",
  EMAIL = "email",
  ANALYTICS = "analytics",
  EMAIL_CAMPAIGN = "email_campaign",
}
